import React, { useState, useRef, useEffect } from "react";
import WindowHeader from "../../../Layout/WindowHeader/WindowHeader";
import ActionToolbar from "../../../NavBars/ActionToolbar";
import SherComboBox from "../../../ComboBoxes/SherComboBox";
import ssLogo from "../../../../assets/images/sslogo.png";
import axios from "axios";
import { useDbContext } from "../../../../context/DbContext";
import { useSelector } from "react-redux";
import { selectMenuPermissions } from "../../../../app/permissionsSlice";
import { selectActiveLocation } from "../../../../app/locationSlice";
import FormDesign, {
  FormDesignProvider,
  useFormDesign,
} from "../../../FormDesign/FormDesign";
import io from "socket.io-client";
import LedgerReg from "../../AccountRegistration/LedgerRegistration/LedgerReg";

const defaultStaffRegFormFields = [
  // ── Form Fields ──
  {
    fieldId: "EmployeeId",
    fieldName: "Employee ID",
    tabIndex: 0,
    type: "Text",
    visible: true,
    enabled: true,
  },
  {
    fieldId: "StaffName",
    fieldName: "Staff Name",
    tabIndex: 1,
    type: "Select",
    visible: true,
    enabled: true,
  },
  {
    fieldId: "Section",
    fieldName: "Section",
    tabIndex: 2,
    type: "Text",
    visible: true,
    enabled: true,
  },
  {
    fieldId: "CashAccount",
    fieldName: "Cash Account",
    tabIndex: 3,
    type: "Select",
    visible: true,
    enabled: true,
  },
  {
    fieldId: "Location",
    fieldName: "Location",
    tabIndex: 4,
    type: "Select",
    visible: true,
    enabled: true,
  },
  {
    fieldId: "Gender",
    fieldName: "Gender",
    tabIndex: 5,
    type: "Radio",
    visible: true,
    enabled: true,
  },
  {
    fieldId: "Address1",
    fieldName: "Address Line 1",
    tabIndex: 6,
    type: "Text",
    visible: true,
    enabled: true,
  },
  {
    fieldId: "Address2",
    fieldName: "Address Line 2",
    tabIndex: 7,
    type: "Text",
    visible: true,
    enabled: true,
  },
  {
    fieldId: "Address3",
    fieldName: "Address Line 3",
    tabIndex: 8,
    type: "Text",
    visible: true,
    enabled: true,
  },
  {
    fieldId: "Mobile",
    fieldName: "Mobile Number",
    tabIndex: 9,
    type: "Number",
    visible: true,
    enabled: true,
  },
  {
    fieldId: "Commission",
    fieldName: "Commission %",
    tabIndex: 11,
    type: "Number",
    visible: true,
    enabled: true,
  },
  {
    fieldId: "Active",
    fieldName: "Active Status",
    tabIndex: 12,
    type: "Checkbox",
    visible: true,
    enabled: true,
  },
  // ── Action Toolbar Buttons ──
  {
    fieldId: "SaveBtn",
    fieldName: "Save",
    tabIndex: 10,
    type: "Button",
    visible: true,
    enabled: true,
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "ClearBtn",
    fieldName: "Clear",
    tabIndex: 21,
    type: "Button",
    visible: true,
    enabled: true,
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "FindBtn",
    fieldName: "Find",
    tabIndex: 22,
    type: "Button",
    visible: true,
    enabled: true,
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "EditBtn",
    fieldName: "Edit",
    tabIndex: 23,
    type: "Button",
    visible: true,
    enabled: true,
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "DeleteBtn",
    fieldName: "Delete",
    tabIndex: 24,
    type: "Button",
    visible: true,
    enabled: true,
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "ExitBtn",
    fieldName: "Exit",
    tabIndex: 25,
    type: "Button",
    visible: true,
    enabled: true,
    fontSize: 11,
    fontStyle: "Normal",
  },
];

function StaffReg(props) {
  const { dbCode } = useDbContext();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  return (
    <FormDesignProvider
      formName="STAFF REGISTRATION"
      defaultFields={defaultStaffRegFormFields}
      dbCode={dbCode}
      apiBaseUrl={apiBaseUrl}
    >
      <StaffRegInner {...props} />
    </FormDesignProvider>
  );
}

function StaffRegInner({ onClose, zIndex, Open, ledgerJustClosed }) {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { dbCode } = useDbContext();
  const permissions = useSelector(selectMenuPermissions);
  const activeLocation = useSelector(selectActiveLocation);

  const [dataFound, setDataFound] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [editDisabled, setEditDisabled] = useState(true);
  const [deleteDisabled, setDeleteDisabled] = useState(true);
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [activeTab, setActiveTab] = useState("Details");
  const [showFormDesignModal, setShowFormDesignModal] = useState(false);
  const [showLocalLedgerModal, setShowLocalLedgerModal] = useState(false);
  const [localLedval, setLocalLedval] = useState("");
  const [localUnder, setLocalUnder] = useState("");
  const isCheckingCashAccountRef = useRef(false);

  const [formData, setFormData] = useState({
    sr_empid: "",
    sr_Name: "",
    sr_Section: "",
    sr_cashAcc: "",
    sr_Location: activeLocation ? activeLocation.id : "",
    sr_Gender: "Male",
    sr_Address1: "",
    sr_Address2: "",
    sr_Address3: "",
    sr_Mobile: "",
    sr_Type: "EMPLOYEE",
    sr_DateOj: "",
    sr_Salary: "",
    sr_OtRate: "",
    sr_OtHour: "",
    sr_LeaveDeduction: "",
    sr_DailyAllowance: "",
    sr_Active: 1,
    sr_CasualLeave: "",
    sr_Branch: "",
    sr_CommissionStatus: "",
    sr_Percent: "",
    sr_Pf: "",
    sr_WorkingHours: "",
    sr_Ledger: "",
    sr_UserName: "",
    sr_Password: "",
  });

  const [selectcashAcc, setselectcashAcc] = useState([]);
  const [locationOpts, setLocationOpts] = useState([]);
  const [employeeNames, setEmployeeNames] = useState([]);
  const [Names, setNames] = useState([]);

  const idInputRef = useRef(null);
  const nameInputRef = useRef(null);
  const sectionInputRef = useRef(null);
  const genderInputRef = useRef(null);
  const address1InputRef = useRef(null);
  const address2InputRef = useRef(null);
  const address3InputRef = useRef(null);
  const mobileInputRef = useRef(null);
  const percentInputRef = useRef(null);
  const cashAccInputRef = useRef(null);
  const locationInputRef = useRef(null);
  const saveButtonRef = useRef(null);

  // ── FormDesign Hook Integration ──
  const {
    fields: formFields,
    loading: formDesignerLoading,
    registerRef,
    registerTabSwitcher,
    handleKeyDown: handleDynamicKeyDown,
    focusField,
    getLabelStyle: getLabelStyleRaw,
    getInputStyle: getInputStyleRaw,
    getContainerStyle,
    isFieldVisible,
    isFieldDisabled,
    isFieldReadOnly,
    getFieldConfig,
    triggerInitialFocus,
  } = useFormDesign();

  const getLabelStyle = (fieldId, defaultStyles = {}) => {
    const fullStyle = getLabelStyleRaw(fieldId, defaultStyles);
    const filtered = { ...defaultStyles, fontFamily: "Inter, sans-serif" };
    if (fullStyle.fontSize) filtered.fontSize = fullStyle.fontSize;
    if (fullStyle.fontWeight) filtered.fontWeight = fullStyle.fontWeight;
    if (fullStyle.fontStyle) filtered.fontStyle = fullStyle.fontStyle;
    if (fullStyle.color) filtered.color = fullStyle.color;
    return filtered;
  };

  const getInputStyle = (fieldId, defaultStyles = {}) => {
    const fullStyle = getInputStyleRaw(fieldId, defaultStyles);
    const filtered = { ...defaultStyles, fontFamily: "Inter, sans-serif" };
    if (fullStyle.fontSize) filtered.fontSize = fullStyle.fontSize;
    if (fullStyle.fontWeight) filtered.fontWeight = fullStyle.fontWeight;
    if (fullStyle.color) filtered.color = fullStyle.color;
    if (fullStyle.backgroundColor)
      filtered.backgroundColor = fullStyle.backgroundColor;
    return filtered;
  };

  const fetchEmployeeNames = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/getEmployeeNames/${dbCode}`,
      );
      const empNames = response.data.map((item) => ({
        value: item.Auto,
        label: item.name,
      }));
      setEmployeeNames(empNames);
      setNames(response.data.map((item) => item.name));
    } catch (error) {
      console.error("Error fetching employee names:", error.message);
    }
  };

  const fetchEmployeeId = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/getEmployeeId/${dbCode}`,
      );
      setFormData((prevData) => ({
        ...prevData,
        sr_empid: response.data[0]?.id || "",
      }));
    } catch (error) {
      console.error("Error fetching employee ID:", error.message);
    }
  };

  const fetchCashAccounts = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRec_caba/${dbCode}`,
      );
      const caba = response.data;
      const transformedData = caba.map((item) => ({
        value: item.ledcode,
        label: item.LedName,
      }));
      setselectcashAcc(transformedData);
      return transformedData;
    } catch (error) {
      console.error("Error fetching selectcashAcc Values:", error.message);
      return [];
    }
  };

  const handleRefreshCashAccounts = async () => {
    const updated = await fetchCashAccounts();
    if (sessionStorage.getItem("staffRegCashAccountFocus") === "true") {
      const typedName = sessionStorage.getItem("staffRegTypedCashAccount");
      if (typedName && Array.isArray(updated)) {
        const matched = updated.find(
          (item) => item.label?.toLowerCase() === typedName.toLowerCase(),
        );
        if (matched) {
          setFormData((prev) => ({
            ...prev,
            sr_cashAcc: matched.value,
          }));
        }
        sessionStorage.removeItem("staffRegTypedCashAccount");
      }
      setTimeout(() => {
        if (cashAccInputRef.current) {
          if (cashAccInputRef.current.focusInput) {
            cashAccInputRef.current.focusInput();
          } else if (cashAccInputRef.current.focus) {
            cashAccInputRef.current.focus();
          }
        }
      }, 100);
      sessionStorage.removeItem("staffRegCashAccountFocus");
    }
    return updated;
  };

  const handleCheckCashAccount = (e) => {
    if (isCheckingCashAccountRef.current) return;
    const targetValue = (e?.target?.value || "").trim();
    if (!targetValue) return;

    const matched = selectcashAcc.find(
      (item) =>
        item.label?.toLowerCase() === targetValue.toLowerCase() ||
        String(item.value) === targetValue,
    );

    if (matched) {
      setFormData((prev) => ({ ...prev, sr_cashAcc: matched.value }));
      return;
    }

    isCheckingCashAccountRef.current = true;
    alert("Cash Account Not Registered");
    sessionStorage.setItem("staffRegCashAccountFocus", "true");
    sessionStorage.setItem("staffRegTypedCashAccount", targetValue);
    if (Open) {
      Open(e, cashAccInputRef);
    } else {
      setLocalLedval(targetValue);
      setLocalUnder("CASH IN HAND");
      setShowLocalLedgerModal(true);
    }
    setTimeout(() => {
      isCheckingCashAccountRef.current = false;
    }, 500);
  };

  const fetchLocationOpts = async () => {
    if (!dbCode) return;
    try {
      const response = await axios.get(
        `${apiBaseUrl}/otherregistration/getoptions/${dbCode}`,
      );
      if (Array.isArray(response.data)) {
        const locations = response.data
          .filter(
            (rec) =>
              String(rec.Type || rec.type || "").toLowerCase() === "location",
          )
          .map((rec) => ({
            label: rec.Name || rec.name || "",
            value: rec.Auto || rec.auto || rec.SlNo || rec.slno || "",
          }));
        setLocationOpts(locations);
      }
    } catch (error) {
      console.error("Error fetching location options:", error.message);
    }
  };

  useEffect(() => {
    if (dbCode) {
      fetchEmployeeNames();
      fetchEmployeeId();
      fetchCashAccounts();
      fetchLocationOpts();
    }
  }, [apiBaseUrl, dbCode]);

  useEffect(() => {
    const socket = io(apiBaseUrl);

    socket.on("LedgerUpdated", () => {
      handleRefreshCashAccounts();
    });

    socket.on("dataUpdated", () => {
      handleRefreshCashAccounts();
    });

    socket.on("EmployeeUpdated", () => {
      fetchEmployeeNames();
      fetchEmployeeId();
    });

    return () => {
      socket.disconnect();
    };
  }, [apiBaseUrl, dbCode]);

  useEffect(() => {
    if (ledgerJustClosed) {
      handleRefreshCashAccounts();
    }
  }, [ledgerJustClosed]);

  useEffect(() => {
    setTimeout(() => {
      triggerInitialFocus();
    }, 150);
  }, []);

  // ── Register tab-switcher callbacks ──
  // Fields in the RIGHT column are split across two conditional tab panels.
  // When FormDesign's focusField tries to focus a field that is in an inactive
  // (unmounted) tab, it will call the switcher first, then retry focus after
  // React re-renders the panel.
  useEffect(() => {
    // "Contact Info" tab fields
    const switchToDetails = () => setActiveTab("Details");
    registerTabSwitcher("Address1", switchToDetails);
    registerTabSwitcher("Address2", switchToDetails);
    registerTabSwitcher("Address3", switchToDetails);
    registerTabSwitcher("Mobile",   switchToDetails);

    // "Payroll" tab fields
    const switchToPayroll = () => setActiveTab("default");
    registerTabSwitcher("Commission", switchToPayroll);
    registerTabSwitcher("Active",     switchToPayroll);
  }, [registerTabSwitcher]);

  const handleClear = () => {
    fetchEmployeeId();
    setFormData({
      sr_empid: "",
      sr_Name: "",
      sr_Section: "",
      sr_cashAcc: "",
      sr_Location: activeLocation ? activeLocation.id : "",
      sr_Gender: "Male",
      sr_Address1: "",
      sr_Address2: "",
      sr_Address3: "",
      sr_Mobile: "",
      sr_Type: "EMPLOYEE",
      sr_DateOj: "",
      sr_Salary: "",
      sr_OtRate: "",
      sr_OtHour: "",
      sr_LeaveDeduction: "",
      sr_DailyAllowance: "",
      sr_Active: 1,
      sr_CasualLeave: "",
      sr_Branch: "",
      sr_CommissionStatus: "",
      sr_Percent: "",
      sr_Pf: "",
      sr_WorkingHours: "",
      sr_Ledger: "",
      sr_UserName: "",
      sr_Password: "",
    });
    fetchEmployeeNames();
    setDataFound(false);
    setEditDisabled(true);
    setDeleteDisabled(true);
    setSaveDisabled(false);
    nameInputRef.current?.clearInput?.();
    triggerInitialFocus();
  };

  const handleSubmit = async () => {
    if (isLoading) return;
    const nameStr = formData.sr_Name?.name ?? String(formData.sr_Name ?? "");
    if (!nameStr || !formData.sr_Section) {
      alert("Please enter both Employee Name and Section.");
      return;
    }
    if (Names.includes(nameStr.trim())) {
      alert("Duplicate entry! Employee name already exists.");
      return;
    }
    if (formData.sr_Mobile && String(formData.sr_Mobile).length !== 10) {
      alert("Mobile number must be exactly 10 digits.");
      return;
    }

    if (!window.confirm(`Save employee "${nameStr}"?`)) return;

    setIsLoading(true);
    try {
      const payload = {
        ...formData,
        sr_Name: nameStr,
        // sr_cashAcc is stored as plain ID - send directly
        sr_cashAcc: formData.sr_cashAcc,
      };
      const response = await axios.post(
        `${apiBaseUrl}/main/insertSalesman/${dbCode}`,
        payload,
      );
      if (response.status === 200) {
        alert("Employee Registered Successfully!");
        handleClear();
      }
    } catch (error) {
      console.error("Error submitting data:", error.message);
      alert("Error saving employee.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = async () => {
    if (isLoading) return;
    const nameStr = formData.sr_Name?.name ?? String(formData.sr_Name ?? "");
    if (!nameStr || !formData.sr_Section) {
      alert("Enter Data Correctly");
      return;
    }
    if (formData.sr_Mobile && String(formData.sr_Mobile).length !== 10) {
      alert("Invalid Mobile Number.");
      return;
    }

    if (!window.confirm(`Update employee details for "${nameStr}"?`)) return;

    setIsLoading(true);
    try {
      const payload = {
        ...formData,
        sr_Name: nameStr,
        // sr_cashAcc is stored as plain ID - send directly
        sr_cashAcc: formData.sr_cashAcc,
      };
      const response = await axios.post(
        `${apiBaseUrl}/main/updateSalesman/${dbCode}`,
        payload,
      );
      if (response.status === 200) {
        alert("Employee Details Updated!");
        handleClear();
      }
    } catch (error) {
      console.error("Error editing data:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async () => {
    if (isLoading) return;
    const nameStr = formData.sr_Name?.name ?? String(formData.sr_Name ?? "");
    if (!nameStr) return;
    if (!window.confirm(`Are you sure you want to delete "${nameStr}"?`))
      return;

    setIsLoading(true);
    try {
      const response = await axios.delete(
        `${apiBaseUrl}/main/deleteSalesman/${encodeURIComponent(nameStr)}/${dbCode}?locationId=${activeLocation ? activeLocation.id : ''}`,
      );
      if (response.status === 200) {
        alert(response.data.message || "Employee Deleted Successfully!");
        handleClear();
      }
    } catch (error) {
      console.error("Error deleting data:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const formatDate = (inputDate) => {
    if (!inputDate) return "";
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleFind = async () => {
    // Resolve the Auto (numeric ID) — either from the object stored on select,
    // or by looking up the typed name string in employeeNames options
    let autoId = formData.sr_Name?.id;
    if (!autoId) {
      const typedName = String(formData.sr_Name ?? "")
        .trim()
        .toLowerCase();
      if (!typedName) {
        alert("Select or type a staff name to find.");
        return;
      }
      const match = employeeNames.find(
        (opt) => opt.label.trim().toLowerCase() === typedName,
      );
      if (!match) {
        alert("Employee not found. Please select from the dropdown.");
        return;
      }
      autoId = match.value;
    }
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/getEmployeeByName/${autoId}/${dbCode}`,
      );
      const foundData = response.data[0];
      if (foundData) {
        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);

        setFormData({
          ...formData,
          sr_empid: foundData.emp_code || "",
          sr_Name: foundData.Name
            ? { id: foundData.emp_code, name: foundData.Name }
            : "",
          sr_Section: foundData.EmployeeSection || "",
          sr_cashAcc: foundData.cashAcc || "",
          sr_Location: foundData.Location || "",
          sr_Gender: foundData.Gender || "Male",
          sr_Address1: foundData.Address1 || "",
          sr_Address2: foundData.address2 || "",
          sr_Address3: foundData.address3 || "",
          sr_Mobile: foundData.Mobile || "",
          sr_Type: foundData.Type || "EMPLOYEE",
          sr_DateOj: formatDate(foundData.DDate) || "",
          sr_Salary: foundData.Salary || "",
          sr_OtRate: foundData.OT || "",
          sr_OtHour: foundData.othour || "",
          sr_LeaveDeduction: foundData.LiveDeduction || "",
          sr_DailyAllowance: foundData.DAllowance || "",
          sr_Active: foundData.Active !== undefined ? foundData.Active : 1,
          sr_CasualLeave: foundData.CashualLeave || "",
          sr_CommissionStatus: foundData.salescomStatus || "",
          sr_Percent: foundData.commisionper || "",
          sr_Pf: foundData.pf || "",
          sr_WorkingHours: foundData.WorkingHour || "",
          sr_UserName: foundData.userName || "",
          sr_Password: foundData.password || "",
        });
        setDataFound(true);
      } else {
        alert("Employee record not found.");
      }
    } catch (error) {
      console.error("Error finding record:", error.message);
    }
  };

  const getItemValue = (val) => {
    if (Array.isArray(val)) return val[1] || "";
    return val || "";
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-slate-900/60 backdrop-blur-xs p-3 font-Inter select-none"
      style={{ zIndex: zIndex || 101, fontFamily: "Inter, sans-serif" }}
    >
      <div className="bg-white font-normal w-[800px] max-w-[95vw] h-auto rounded-xl shadow-2xl flex flex-col overflow-hidden border border-slate-200">
        {/* Header */}
        <WindowHeader
          title="Staff / Employee Registration"
          logo={ssLogo}
          onClose={onClose}
          className="!h-9"
          titleClassName="!text-xs"
          logoClassName="!h-4"
          closeBtnClassName="w-6 h-6 border-none rounded-[5px] mr-2"
        />

        {/* Toolbar */}
        <div className="w-full flex-shrink-0">
          <ActionToolbar
            ref={(el) => {
              if (el) {
                registerRef("SaveBtn")(el.saveButtonRef?.current);
                registerRef("ClearBtn")(el.clearButtonRef?.current);
                registerRef("FindBtn")(el.findButtonRef?.current);
                registerRef("EditBtn")(el.editButtonRef?.current);
                registerRef("DeleteBtn")(el.deleteButtonRef?.current);
                registerRef("ExitBtn")(el.exitButtonRef?.current);
              }
            }}
            width="100%"
            height="auto"
            bgColor="#EAF0FC"
            size="small"
            iconSize={16}
            showSave={true}
            showPrint={false}
            showClear={true}
            showFind={true}
            showEdit={true}
            showDelete={true}
            showExit={true}
            showNavigation={false}
            saveDisabled={dataFound || saveDisabled}
            editDisabled={!dataFound || editDisabled}
            deleteDisabled={!dataFound || deleteDisabled}
            dataFound={dataFound}
            onSave={handleSubmit}
            onClear={handleClear}
            onFind={handleFind}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onExit={onClose}
            showSettingsBar={true}
            settingsOptions={[
              {
                label: "Form Design",
                onClick: () => setShowFormDesignModal(true),
              },
            ]}
          />
        </div>

        {/* Body Layout */}
        <div className="w-full flex-1 p-4 bg-slate-50 flex flex-col gap-4">
          <div className="grid grid-cols-2 gap-4">
            {/* LEFT COLUMN: Identity & Info */}
            <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-xs flex flex-col gap-3 h-[310px]">
              <h3 className="text-[10px] font-extrabold text-[#1a3abf] uppercase tracking-wider border-b border-slate-100 pb-1 m-0 font-Inter">
                Staff Profile Details
              </h3>

              <div className="grid grid-cols-3 gap-2 items-center">
                {/* Employee ID */}
                {isFieldVisible("EmployeeId") && (
                  <>
                    <label
                      className="text-[11.5px] font-bold text-slate-700 font-Inter"
                      style={getLabelStyle("EmployeeId")}
                    >
                      Employee ID
                    </label>
                    <input
                      ref={(el) => {
                        registerRef("EmployeeId")(el);
                        idInputRef.current = el;
                      }}
                      disabled={isFieldDisabled("EmployeeId")}
                      readOnly={isFieldReadOnly("EmployeeId")}
                      style={getInputStyle("EmployeeId")}
                      type="text"
                      value={formData.sr_empid}
                      onChange={(e) =>
                        setFormData({ ...formData, sr_empid: e.target.value })
                      }
                      placeholder="ID"
                      onKeyDown={(e) => handleDynamicKeyDown(e, "EmployeeId")}
                      className="col-span-2 h-8 px-2.5 text-xs font-semibold text-center border border-slate-300 rounded-md outline-none bg-slate-100/50 font-Inter"
                    />
                  </>
                )}

                {/* Name */}
                {isFieldVisible("StaffName") && (
                  <>
                    <label
                      className="text-[11.5px] font-bold text-slate-700 font-Inter"
                      style={getLabelStyle("StaffName")}
                    >
                      Staff Name *
                    </label>
                    <div className="col-span-2">
                      <SherComboBox
                        comboRef={(el) => {
                          registerRef("StaffName")(el);
                          nameInputRef.current = el;
                        }}
                        disabled={isFieldDisabled("StaffName")}
                        readOnly={isFieldReadOnly("StaffName")}
                        options={employeeNames}
                        value={formData.sr_Name?.name ?? formData.sr_Name}
                        onSelect={(opt) =>
                          setFormData({
                            ...formData,
                            sr_Name: { id: opt.value, name: opt.label },
                          })
                        }
                        // onInputChange intentionally omitted — SherComboBox fires it with label text
                        // right after onSelect, which would overwrite the stored ID with a string
                        onFreeInput={(text) =>
                          setFormData({ ...formData, sr_Name: text })
                        }
                        onKeyDown={(e) => handleDynamicKeyDown(e, "StaffName")}
                        placeholder="Choose name.."
                        inputWidth="100%"
                        inputHeight="32px"
                        inputClassName="border border-slate-300 rounded-md focus:border-blue-600 shadow-2xs font-Inter"
                        inputStyle={{
                          fontSize: "11px",
                          paddingLeft: "6px",
                          ...getInputStyle("StaffName"),
                        }}
                      />
                    </div>
                  </>
                )}

                {/* Section */}
                {isFieldVisible("Section") && (
                  <>
                    <label
                      className="text-[11.5px] font-bold text-slate-700 font-Inter"
                      style={getLabelStyle("Section")}
                    >
                      Section *
                    </label>
                    <input
                      ref={(el) => {
                        registerRef("Section")(el);
                        sectionInputRef.current = el;
                      }}
                      disabled={isFieldDisabled("Section")}
                      readOnly={isFieldReadOnly("Section")}
                      style={getInputStyle("Section")}
                      type="text"
                      value={formData.sr_Section}
                      onChange={(e) =>
                        setFormData({ ...formData, sr_Section: e.target.value })
                      }
                      placeholder="e.g. Sales Counter"
                      onKeyDown={(e) => handleDynamicKeyDown(e, "Section")}
                      className="col-span-2 h-8 px-2.5 text-xs font-medium border border-slate-300 rounded-md outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-500 font-Inter"
                    />
                  </>
                )}

                {/* Cash Account */}
                {isFieldVisible("CashAccount") && (
                  <>
                    <label
                      className="text-[11.5px] font-bold text-slate-700 font-Inter"
                      style={getLabelStyle("CashAccount")}
                    >
                      Cash Account
                    </label>
                    <div className="col-span-2">
                      <SherComboBox
                        comboRef={(el) => {
                          registerRef("CashAccount")(el);
                          cashAccInputRef.current = el;
                        }}
                        disabled={isFieldDisabled("CashAccount")}
                        readOnly={isFieldReadOnly("CashAccount")}
                        options={selectcashAcc}
                        value={formData.sr_cashAcc}
                        onSelect={(opt) =>
                          setFormData({ ...formData, sr_cashAcc: opt.value })
                        }
                        // onInputChange intentionally omitted — SherComboBox fires it with label text
                        // right after onSelect, which would overwrite the numeric ID with a string → NaN → null in SP
                        onFreeInput={(text) =>
                          setFormData({ ...formData, sr_cashAcc: text })
                        }
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            const val = (e.target?.value || "").trim();
                            if (val) {
                              const isPresent = selectcashAcc.some(
                                (item) =>
                                  item.label?.toLowerCase() === val.toLowerCase() ||
                                  String(item.value) === val,
                              );
                              if (!isPresent) {
                                e.preventDefault();
                                e.stopPropagation();
                                handleCheckCashAccount(e);
                                return;
                              }
                            }
                          }
                          handleDynamicKeyDown(e, "CashAccount");
                        }}
                        onBlur={(e) => handleCheckCashAccount(e)}
                        placeholder="Choose cash account.."
                        inputWidth="100%"
                        inputHeight="32px"
                        inputClassName="border border-slate-300 rounded-md focus:border-blue-600 shadow-2xs font-Inter"
                        inputStyle={{
                          fontSize: "11px",
                          paddingLeft: "6px",
                          ...getInputStyle("CashAccount"),
                        }}
                      />
                    </div>
                  </>
                )}

                {/* Location */}
                {isFieldVisible("Location") && (
                  <>
                    <label
                      className="text-[11.5px] font-bold text-slate-700 font-Inter"
                      style={getLabelStyle("Location")}
                    >
                      Location
                    </label>
                    <div className="col-span-2">
                      <SherComboBox
                        comboRef={(el) => {
                          registerRef("Location")(el);
                          locationInputRef.current = el;
                        }}
                        disabled={isFieldDisabled("Location")}
                        readOnly={isFieldReadOnly("Location")}
                        options={locationOpts}
                        value={formData.sr_Location}
                        onSelect={(opt) =>
                          setFormData({ ...formData, sr_Location: opt.value })
                        }
                        onFreeInput={(text) =>
                          setFormData({ ...formData, sr_Location: text })
                        }
                        onKeyDown={(e) => handleDynamicKeyDown(e, "Location")}
                        placeholder="Choose location.."
                        inputWidth="100%"
                        inputHeight="32px"
                        inputClassName="border border-slate-300 rounded-md focus:border-blue-600 shadow-2xs font-Inter"
                        inputStyle={{
                          fontSize: "11px",
                          paddingLeft: "6px",
                          ...getInputStyle("Location"),
                        }}
                      />
                    </div>
                  </>
                )}

                {/* Gender */}
                {isFieldVisible("Gender") && (
                  <>
                    <label
                      className="text-[11.5px] font-bold text-slate-700 font-Inter"
                      style={getLabelStyle("Gender")}
                    >
                      Gender
                    </label>
                    <div className="col-span-2 flex items-center gap-4 text-xs font-semibold text-slate-700 py-1 font-Inter">
                      <label className="flex items-center gap-1.5 cursor-pointer font-Inter">
                        <input
                          ref={registerRef("Gender")}
                          type="radio"
                          name="gender"
                          value="Male"
                          checked={formData.sr_Gender === "Male"}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sr_Gender: e.target.value,
                            })
                          }
                          onKeyDown={(e) => handleDynamicKeyDown(e, "Gender")}
                          className="w-3.5 h-3.5 accent-blue-600 cursor-pointer"
                          disabled={isFieldDisabled("Gender")}
                        />
                        Male
                      </label>
                      <label className="flex items-center gap-1.5 cursor-pointer font-Inter">
                        <input
                          type="radio"
                          name="gender"
                          value="Female"
                          checked={formData.sr_Gender === "Female"}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sr_Gender: e.target.value,
                            })
                          }
                          onKeyDown={(e) => handleDynamicKeyDown(e, "Gender")}
                          className="w-3.5 h-3.5 accent-blue-600 cursor-pointer font-Inter"
                          disabled={isFieldDisabled("Gender")}
                        />
                        Female
                      </label>
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* RIGHT COLUMN: Contact & Payroll */}
            <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-xs flex flex-col gap-3 h-[310px]">
              <h3 className="text-[10px] font-extrabold text-[#1a3abf] uppercase tracking-wider border-b border-slate-100 pb-1 m-0 font-Inter">
                Contact & Payroll Settings
              </h3>

              {/* Premium Segmented Tab Selector */}
              <div className="flex bg-slate-100 p-1 rounded-lg gap-1 border border-slate-200 text-xs font-bold font-Inter flex-shrink-0">
                <button
                  type="button"
                  onClick={() => setActiveTab("Details")}
                  className={`flex-1 py-1.5 rounded-md text-center transition-all duration-200 font-Inter cursor-pointer ${
                    activeTab === "Details"
                      ? "bg-white text-blue-700 shadow-xs border border-slate-200/60"
                      : "text-slate-600 hover:bg-slate-200/50"
                  }`}
                >
                  Contact Info
                </button>
                <button
                  type="button"
                  onClick={() => setActiveTab("default")}
                  className={`flex-1 py-1.5 rounded-md text-center transition-all duration-200 font-Inter cursor-pointer ${
                    activeTab === "default"
                      ? "bg-white text-blue-700 shadow-xs border border-slate-200/60"
                      : "text-slate-600 hover:bg-slate-200/50"
                  }`}
                >
                  Payroll
                </button>
              </div>

              {activeTab === "Details" && (
                <div className="flex flex-col gap-2">
                  {isFieldVisible("Address1") && (
                    <div
                      className="flex flex-col gap-0.5"
                      style={getContainerStyle("Address1")}
                    >
                      <label
                        className="text-[10px] font-extrabold text-slate-500 uppercase font-Inter"
                        style={getLabelStyle("Address1")}
                      >
                        Street Address
                      </label>
                      <input
                        ref={(el) => {
                          registerRef("Address1")(el);
                        }}
                        disabled={isFieldDisabled("Address1")}
                        readOnly={isFieldReadOnly("Address1")}
                        style={getInputStyle("Address1")}
                        type="text"
                        value={formData.sr_Address1}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            sr_Address1: e.target.value,
                          })
                        }
                        placeholder="Line 1"
                        onKeyDown={(e) => handleDynamicKeyDown(e, "Address1")}
                        className="h-8 px-2.5 text-xs font-medium border border-slate-300 rounded-md outline-none focus:border-blue-600 bg-slate-50/30 font-Inter"
                      />
                    </div>
                  )}

                  {isFieldVisible("Address2") && (
                    <div
                      className="flex flex-col"
                      style={getContainerStyle("Address2")}
                    >
                      <input
                        ref={(el) => {
                          registerRef("Address2")(el);
                        }}
                        disabled={isFieldDisabled("Address2")}
                        readOnly={isFieldReadOnly("Address2")}
                        style={getInputStyle("Address2")}
                        type="text"
                        value={formData.sr_Address2}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            sr_Address2: e.target.value,
                          })
                        }
                        placeholder="Line 2"
                        onKeyDown={(e) => handleDynamicKeyDown(e, "Address2")}
                        className="h-8 px-2.5 text-xs font-medium border border-slate-300 rounded-md outline-none focus:border-blue-600 bg-slate-50/30 font-Inter"
                      />
                    </div>
                  )}

                  {isFieldVisible("Address3") && (
                    <div
                      className="flex flex-col"
                      style={getContainerStyle("Address3")}
                    >
                      <input
                        ref={(el) => {
                          registerRef("Address3")(el);
                        }}
                        disabled={isFieldDisabled("Address3")}
                        readOnly={isFieldReadOnly("Address3")}
                        style={getInputStyle("Address3")}
                        type="text"
                        value={formData.sr_Address3}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            sr_Address3: e.target.value,
                          })
                        }
                        placeholder="City / State"
                        onKeyDown={(e) => handleDynamicKeyDown(e, "Address3")}
                        className="h-8 px-2.5 text-xs font-medium border border-slate-300 rounded-md outline-none focus:border-blue-600 bg-slate-50/30 font-Inter"
                      />
                    </div>
                  )}

                  {isFieldVisible("Mobile") && (
                    <div
                      className="flex flex-col gap-0.5"
                      style={getContainerStyle("Mobile")}
                    >
                      <label
                        className="text-[10px] font-extrabold text-slate-500 uppercase font-Inter"
                        style={getLabelStyle("Mobile")}
                      >
                        Mobile Number
                      </label>
                      <input
                        ref={(el) => {
                          registerRef("Mobile")(el);
                          mobileInputRef.current = el;
                        }}
                        disabled={isFieldDisabled("Mobile")}
                        readOnly={isFieldReadOnly("Mobile")}
                        style={getInputStyle("Mobile")}
                        type="number"
                        value={formData.sr_Mobile}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            sr_Mobile: e.target.value,
                          })
                        }
                        placeholder="10-digit mobile"
                        onKeyDown={(e) => handleDynamicKeyDown(e, "Mobile")}
                        className="h-8 px-2.5 text-xs font-medium border border-slate-300 rounded-md outline-none focus:border-blue-600 bg-slate-50/30 font-Inter"
                      />
                    </div>
                  )}
                </div>
              )}

              {activeTab === "default" && (
                <div className="flex flex-col gap-3 py-2">
                  {isFieldVisible("Commission") && (
                    <div
                      className="flex flex-col gap-1"
                      style={getContainerStyle("Commission")}
                    >
                      <label
                        className="text-[10.5px] font-bold text-slate-700 font-Inter"
                        style={getLabelStyle("Commission")}
                      >
                        Commission %
                      </label>
                      <input
                        ref={(el) => {
                          registerRef("Commission")(el);
                          percentInputRef.current = el;
                        }}
                        disabled={isFieldDisabled("Commission")}
                        readOnly={isFieldReadOnly("Commission")}
                        style={getInputStyle("Commission")}
                        type="number"
                        value={formData.sr_Percent}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            sr_Percent: e.target.value,
                          })
                        }
                        placeholder="e.g. 2.5"
                        onKeyDown={(e) => handleDynamicKeyDown(e, "Commission")}
                        className="h-8 px-2.5 text-xs font-medium border border-slate-300 rounded-md outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-500 bg-slate-50/30 font-Inter"
                      />
                    </div>
                  )}

                  {isFieldVisible("Active") && (
                    <div
                      className="flex items-center gap-2 mt-2"
                      style={getContainerStyle("Active")}
                    >
                      <input
                        ref={(el) => {
                          registerRef("Active")(el);
                        }}
                        disabled={isFieldDisabled("Active")}
                        type="checkbox"
                        id="staffActive"
                        checked={formData.sr_Active === 1}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            sr_Active: e.target.checked ? 1 : 0,
                          })
                        }
                        className="w-4 h-4 accent-blue-600 cursor-pointer"
                      />
                      <label
                        htmlFor="staffActive"
                        className="text-[12px] font-bold text-slate-700 cursor-pointer font-Inter"
                        style={getLabelStyle("Active")}
                      >
                        Active Status (Mark as active to allow sales
                        attribution)
                      </label>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Quick Info Bar */}
          <div className="bg-blue-50/70 border border-blue-100 rounded-lg p-2.5 flex items-center gap-2 text-blue-700 text-xs">
            <span className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-ping" />
            <span className="font-medium">
              Note: Staff registration creates salesman profiles automatically
              linked with daily sales/billing commissions.
            </span>
          </div>
        </div>
      </div>

      {/* Form Design Settings Modal */}
      {showFormDesignModal && (
        <FormDesign
          onClose={() => setShowFormDesignModal(false)}
          formName="STAFF REGISTRATION"
          initialFields={defaultStaffRegFormFields}
          zIndex={(zIndex || 100) + 50}
        />
      )}

      {/* Local Ledger Registration Modal (fallback if not using homepage modal manager) */}
      {showLocalLedgerModal && (
        <LedgerReg
          onClose={() => {
            setShowLocalLedgerModal(false);
            setLocalLedval("");
            setLocalUnder("");
            handleRefreshCashAccounts();
          }}
          val={localLedval || ""}
          underVal={localUnder || "CASH IN HAND"}
          zIndex={(zIndex || 101) + 20}
        />
      )}
    </div>
  );
}

export default StaffReg;
